export default {
    cancel: 'cancel',
    save: 'save',
    blacklist: 'Blacklist',
    createBlacklist: 'Create New Blacklist',
    editBlacklist: 'Edit Blacklist',
    profile: 'Profile',
    name: 'Name',
    surname: 'Surname',
    reason: 'Blacklist reason (Optional)',
    status: 'Blacklist Status',
    placeholderReason: 'Write the reason',
    information: 'Information',
    requireField: 'This field is required.',
    imageSuggestionText: 'Image size must be between 25KB and 200KB',
    createdBlacklist: 'Blacklist was created.',
    editedBlacklist: 'Blacklist was updated.',
    somethingWrong: 'Something Wrong!!',
    imageCannotBeEmpty: 'Image cannot be empty.',
    congratulation: 'Congratulation',
    reasonShown: 'Blacklist reason'
}
